import React from 'react';
import {CardNFT} from "../../components/CardList/Card";

const CardAvailableList = ({cards, currentPage, cardsPerPage}) => {
    const indexOfLastCard = currentPage * cardsPerPage;
    const indexOfFirstCard = indexOfLastCard - cardsPerPage;
    const currentCards = cards.slice(indexOfFirstCard, indexOfLastCard); 
    const filtData = currentCards.sort((a, b) => 0.5 - Math.random());
    return (
            <React.Fragment>
                {filtData.map(({id, meta, bestSellOrder, OId}, index) => {
                    return (
                  <CardNFT
                    key={index}
                    mapKey={index}
                    uuid={id}
                    id={id}
                    name={meta.name}
                    isImg={!!meta.content[1]}
                    image={meta.content[0].url}
                    video={meta.content[1] ? meta.content[1].url : ""}
                    sales={bestSellOrder.makePrice}
                    openSeaLink={OId}
                    />
                )
                }).reverse()} 
            </React.Fragment>
    );
};

export default CardAvailableList;